import * as DetailActions from '../actions/detail.actions';
import {createReducer, on} from '@ngrx/store';

export interface State {
    isDetailTextOpen: boolean;
    isSafetyTextOpen: boolean;
    isFreeTextActive: boolean;
    selectedQuantity: number;
}

const initialState: State = {
    isDetailTextOpen: false,
    isSafetyTextOpen: false,
    isFreeTextActive: false,
    selectedQuantity: 1
};

export const reducer = createReducer(
    initialState,
    on(DetailActions.openDetailText, state => ({...state, isDetailTextOpen: true})),
    on(DetailActions.closeDetailText, state => ({...state, isDetailTextOpen: false})),
    on(DetailActions.openSafetyText, state => ({...state, isSafetyTextOpen: true})),
    on(DetailActions.closeSafetyText, state => ({...state, isSafetyTextOpen: false})),
    on(DetailActions.activateFreeText, state => ({...state, isFreeTextActive: true})),
    on(DetailActions.selectedQuantity, (state, {selectedQuantity}) => ({...state, selectedQuantity: selectedQuantity}))
);

export const getIsDetailTextOpen = (state: State) => state.isDetailTextOpen;
export const getIsSafetyMenuOpen = (state: State) => state.isSafetyTextOpen;
export const getIsFreeTextActive = (state: State) => state.isFreeTextActive;
export const getSelectedQuantity = (state: State) => state.selectedQuantity;
